import React, { useState, useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

// i18n
import "./i18n/i18n";

// DESKTOP IMPORTS
import Home from "./pages/Home";
import SearchResults from "./pages/SearchResults";
import CategoryItems from "./pages/CategoryItems";
import CustomGarland from "./pages/CustomGarland";
import AdminGarlandReview from "./admin/AdminGarlandReview";
import CourierOrder from "./pages/CourierOrder";
import MyOrders from "./pages/MyOrders";
import MyAddress from "./pages/MyAddress";
import AboutUs from "./pages/AboutUs";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import AdminItemsList from "./admin/Adminitemslist";
import Address from "./pages/Address";
import AccessoriesComingSoon from "./pages/AccessoriesComingSoon"; 

// PROTECTED ROUTE
import ProtectedRoute from "./components/ProtectedRoute";

// Obscure, hard-to-guess admin URLs
import { ADMIN_LOGIN_PATH, ADMIN_DASHBOARD_PATH, ADMIN_ITEMS_PATH, ADMIN_MOBILE_PATH } from "./admin/Adminpaths";

// MOBILE IMPORTS
import MobileHome from "./mobile/MobileHome";
import MobileSearchResults from "./mobile/MobileSearchResults";
import MobileItemsList from "./mobile/MobileItemsList";
import MobileGarlandOrder from "./mobile/MobileGarlandOrder";
import MobileCourierOrder from "./mobile/MobilecourierOrder";
import MobileAccessoriesComingSoon from "./mobile/MobileAccessories"; 

// ADMIN IMPORTS
import AdminMobileAccessories from "./admin/AdminMobileAccessories"; 

function App() {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= 768
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>

        {/* HOME */}
        <Route
          path="/"
          element={
            isMobile ? <MobileHome /> : <Home />
          }
        />

        <Route
          path="/home"
          element={
            isMobile ? <MobileHome /> : <Home />
          }
        />

        {/* SEARCH */}
        <Route
          path="/search"
          element={
            isMobile
              ? <MobileSearchResults />
              : <SearchResults />
          }
        />

        {/* MOBILE ACCESSORIES */}
        <Route
          path="/category/mobile-accessories"
          element={
            isMobile
              ? <MobileAccessoriesComingSoon />
              : <AccessoriesComingSoon />
          }
        />

        {/* CATEGORY */}
        <Route
          path="/category/:categoryId"
          element={
            isMobile
              ? <MobileItemsList />
              : <CategoryItems />
          }
        />

        {/* MOBILE GARLAND */}
        <Route
          path="/m-garland"
          element={<MobileGarlandOrder />}
        />

        {/* GARLAND */}
        <Route
          path="/garland"
          element={
            isMobile
              ? <MobileGarlandOrder />
              : <CustomGarland />
          }
        />

        <Route
          path="/admin/garland"
          element={<AdminGarlandReview />}
        />

        {/* ADMIN MOBILE ACCESSORIES */}
        <Route
          path={ADMIN_MOBILE_PATH}
          element={
            <ProtectedRoute>
              <AdminMobileAccessories />
            </ProtectedRoute>
          }
        />

        {/* COURIER */}
        <Route
          path="/courier"
          element={
            isMobile
              ? <MobileCourierOrder />
              : <CourierOrder />
          }
        />

        <Route
          path="/custom-garland"
          element={<CustomGarland />}
        />

        {/* USER PAGES */}
        <Route
          path="/my-orders"
          element={<MyOrders />}
        />

        <Route
          path="/my-address"
          element={<MyAddress />}
        />

        <Route
          path="/about-us"
          element={<AboutUs />}
        />

        <Route
          path="/address"
          element={<Address />}
        />

        {/* ADMIN LOGIN */}
        <Route
          path={ADMIN_LOGIN_PATH}
          element={<AdminLogin />}
        />

        {/* PROTECTED ADMIN DASHBOARD */}
        <Route
          path={ADMIN_DASHBOARD_PATH}
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />

        {/* PROTECTED ADMIN ITEMS LIST */}
        <Route
          path={ADMIN_ITEMS_PATH}
          element={
            <ProtectedRoute>
              <AdminItemsList />
            </ProtectedRoute>
          }
        />

        {/* CATCH-ALL */}
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;